import { SkillCategory } from '../types';

export const skills = [
  {
    title: 'AI & Agent Engineering',
    description: 'Autonomous multi-agent orchestration, semantic vector retrieval architectures, and deterministic safety middleware.',
    chips: [
      'LangGraph',
      'LangChain',
      'Multi-Agent Workflows',
      'RAG',
      'pgvector',
      'Tool Calling',
      'Human-in-the-Loop (HITL)',
      'Context Management',
      'Guardrails & Middleware',
      'OpenAI LLM APIs',
      'Prompt Engineering'
    ]
  },
  {
    title: 'Backend & Automation',
    description: 'High-throughput microservices, distributed API designs, asynchronous processing, and robust data persistence.',
    chips: [
      'Python',
      'FastAPI',
      'Java (Java 21)',
      'GraphQL (Apollo/DGS)',
      'REST APIs',
      'SQL',
      'PL/SQL',
      'Microservices Architecture',
      'Validation Microservices',
      'Shell Scripting',
      'Google Apps Script'
    ]
  },
  {
    title: 'Cloud & DevOps',
    description: 'Cloud-native infrastructure, resilient message queues, container orchestration, and continuous integration pipelines.',
    chips: [
      'AWS (S3, ECS, EKS, DynamoDB, RDS, SNS, SQS, Elasticsearch, Elasticache, CloudWatch)',
      'Kubernetes',
      'Docker',
      'Kafka',
      'GitLab CI/CD',
      'GitHub Actions',
      'Jenkins',
      'GitHub Copilot',
      'Claude Code'
    ]
  },
  {
    title: 'Identity & Observability',
    description: 'Fine-grained RBAC provisioning, enterprise relational & NoSQL databases, AIOps, and real-time observability.',
    chips: [
      'Keycloak RBAC',
      'PostgreSQL',
      'Oracle',
      'SQL Server',
      'DynamoDB',
      'Datadog',
      'ServiceNow',
      'Loggly',
      'Streamlit',
      'API Gateway',
      'QuickSight',
      'Looker Studio'
    ]
  }
] as const satisfies readonly SkillCategory[];

export default skills;
